import { Component } from '@angular/core'

@Component({
	template : "<p>you've been banned! If you believe you've been wrongly banned, contact support</p>"
})

export class BannedComponent {
	
}